import { CircularFillCheckmarkIcon } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

interface Props {
  readonly chosen: boolean;
}

const ChooseButtonCheck = ({ chosen }: Props): JSX.Element => {
  const t = useTranslations();

  return (
    <CircularFillCheckmarkIcon
      className={cx('inline-flex size-6 self-center text-slate-200', {
        // toggle visibility so the element always takes space in the layout, reducing "shift"
        invisible: !chosen,
      })}
      aria-hidden={!chosen}
      aria-label={t('pdp_selected_check_label')}
    />
  );
};

export default ChooseButtonCheck;
